<template>
  <div
    v-if="selectedResidence && preview"
    v-loading="loading"
    class="residenceCard"
  >
    <h5>{{ selectedResidence.title }}</h5>
    <div v-if="opened">
      <p class="residenceCard__address">{{ selectedResidence.address + ', ' + selectedResidence.zip_code + ' ' + selectedResidence.city.toUpperCase() }}</p>
      <p><b>{{ preview.preview.quantity }}</b> {{ $t('residences.headerCard.accomodationFrom') }} <b>{{ preview.preview.surface_from }} {{ $t('residences.headerCard.to') }} {{ preview.preview.surface_to }}</b>&nbsp;{{$t('ui.surfaceDisplay.squareFoot')}}</p>
      <p>{{ $t('residences.headerCard.from')}} <b>{{ preview.preview.rent_amount_from }}&nbsp;€/{{ $t('residences.headerCard.perMonth') }}</b></p>
      <!--<p>{{ $t('residences.headerCard.reservedTo')}} <b>{{ 'écoles' }}</b></p>-->
    </div>
  </div>
  <div
    v-else
    class="residenceCard"
  >
    <!-- Added temporarly for consistency purpose -->
    <h5>{{ $t('residences.headerCard.noResidence.title')}}</h5>
    <div v-if="opened">
      <p class="wrap">{{ $t('residences.headerCard.noResidence.text')}}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "ResidenceCard",
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    preview: null
  }),
  computed: {
    ...mapState({
      selectedResidence: state => state.residences.selectedResidence
    })
  },
  async mounted() {
    if (this.selectedResidence) {
      this.loading = true
      try {
        this.preview = await this.$api.residences.getResidencePreview({
          id: this.selectedResidence.id
        })
      } catch (error) {
        console.warn(error)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.residenceCard';

#{$c} {
  padding: 0 10px;

  @include respond-between(xs, lg) {
    padding: 5px 30px;
  }

  @include respond-above(lg) {
    min-width: 300px;
  }

  h5 {
    font-size: 14px;
    font-weight: 600;
    line-height: 36px;
    color: #303133;
  }
  #{$c}__address {
    margin-bottom: 4px;
  }

  p {
    margin: 0;
    line-height: 1.75;
  }

  @include respond-above(lg) {
    p:not(.wrap),
    h5 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>